import { Component } from '@angular/core';
import { ModalController, NavParams, NavController } from 'ionic-angular';



import { MenuService } from '../../../providers/menu-service';
import { AlertService } from '../../../providers/alert-service';
import { GestaoPcaService } from '../../../providers/gestao-pca-service';
import { RolAssinantesService } from "../../../providers/rol-assinantes-service";
import { CadastroAssinantesPage } from "./cadastro-assinante";

import { ModulosController } from '../modulos-controller';
import { UsuarioService } from '../../../providers/usuario-service';

@Component({
  selector: 'page-rol-assinantes',
  templateUrl: 'rol-assinantes.html',
  providers: [
    RolAssinantesService
  ]
})
export class RolAssinantesPage extends ModulosController {

  selectedItem: any;

  moduloId: any;
  PCAAtiva: any;
  listaAssinantes: any = [];
  listaEstados: any = [];
  listaCidadesEnderecoPessoal: any = [];
  listaCidadesEnderecoFuncional: any = [];
  listaTiposTelefone: any = [];
  listaCargos: any = [];

  loading: boolean = true;

  isCGE: boolean = false;
  analise: any = null;

  desabilitarImportacao = true;

  constructor(public rolAssinantesService: RolAssinantesService,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public usuarioService: UsuarioService,
    public navParams: NavParams,
    public gestaoPcaService: GestaoPcaService,
    public alertService: AlertService,
    public menuService: MenuService) {

      super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
  

    this.analise = this.navParams.get('analise');
    this.PCAAtiva = this.gestaoPcaService.getPCA();
    this.isCGE = this.usuarioService.isCGE();
    this.listarAssinantes();

    this.setModuloId(16);
  }

  setModuloId(idModulo) {
    this.moduloId = idModulo;
  }

  abrir(item) {
    this.navCtrl.push(CadastroAssinantesPage, { assinante: item, analise: this.analise });
  }

  listarAssinantes() {
    this.desabilitarImportacao = true; 
    this.listaAssinantes = [];
    this.rolAssinantesService.getRolAssinantes(this.PCAAtiva.id).subscribe(data => {
      this.listaAssinantes = data;
      this.desabilitarImportacao = this.listaAssinantes.length > 0; 
      this.loading = false;
    },
      error => {
        console.log("erro: " + error);

        this.loading = false;

      });
  }

  importarDoAnoAnterior() {

    this.alertService.mostraModalConfirmacao("Importar do Ano Anterior", 
        "Deseja importar os registros do ano anterior?", 
        callback => {            
            if (callback) {
                this.loading = true;
                this.desabilitarImportacao = true;                    
                this.rolAssinantesService.importarAssinantes(this.PCAAtiva.id).subscribe(data => {
                    this.alertService.mostraAlerta("", data.mensagem);
                    this.listarAssinantes();
                }, error => {
                    console.log("erro: " + error.mensagem);
                    this.alertService.mostraAlerta("Erro ao importar", error.mensagem);
                    this.listarAssinantes();
                });
            }
        }
    );
  }

  excluirAssinante(assinante) {
    this.alertService.mostraModalConfirmacao("Excluir assinante",
      "Confirma a exclusão do assinante ?", retorno => {
        if (retorno) {
          this.loading = true;

          this.rolAssinantesService.excluirAssinante(assinante).subscribe(data => {
            this.listarAssinantes();
            this.alertService.mostraAlerta("", "Assinante excluído com sucesso!");
          },
            error => {
              this.alertService.mostraAlerta("", "Ocorreu um erro ao excluir o assinante:" + error.mensagem);
              console.log("erro: " + error);
              this.listarAssinantes();
            });
        } else {
          this.listarAssinantes();
        }
      });
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';
    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

}



// WEBPACK FOOTER //
// ./src/pages/modulos/rol-assinantes/rol-assinantes.ts